import React, { useCallback, useState } from 'react';
import { ATMIcon } from 'shared-it-appmod-ui';
import { Link } from 'react-router-dom';
import Lang from 'src/libraries/language';
import Moment from 'src/libraries/moment.library';
import RequestStatusView from 'src/components/atoms/request-status/request-status.component';
import { getRequestUrl } from 'src/selectors/request.selector';
import { RequestStatus } from 'src/constants';
import { INotification } from 'src/models/notification.model';
import style from '../notification.module.scss';

export type IProps = {
  value: INotification;
};

const NotificationRow: React.FC<IProps> = ({ value }) => {
  const [details, setDetails] = useState(<div />);
  const [text, setText] = useState(Lang.LBL_SHOW_DETAILS);

  const handleHideShow = useCallback(() => {
    if (text === Lang.LBL_SHOW_DETAILS) {
      setDetails(
        <>
          <div className={style.details}>
            <div style={{ float: 'left', width: '5%' }}>
              <ATMIcon
                name="stopwatch"
                color="orange"
                size="large"
                style={{ verticalAlign: 'initial' }}
              />
            </div>
            <div style={{ float: 'left', width: '95%' }}>
              <div
                style={{
                  display: 'inline-block',
                  marginBottom: '5px',
                  width: '100%',
                }}
              >
                <div className={style.floatTl}>
                  <span className={style.boldOrange}>
                    {value.requestStatus === RequestStatus.Cancelled
                      ? `${Lang.LBL_REQUEST_CANCELLED} ${Lang.LBL_BY} ${value.reasonBy}`
                      : `${Lang.LBL_REQUEST_PENDING} ${Lang.LBL_BY} ${value.requestorName}`}
                  </span>
                </div>
                <div className={style.floatTr}>
                  <span>
                    {Moment(value.requestDate).format('MM/DD/YYYY - HHmm')} hrs
                  </span>
                </div>
              </div>
              <div className={style.subDetails}>
                <p className={style.twelvepx}>
                  {Lang.LBL_REQUESTED}:{' '}
                  <span>
                    {Moment(value.requestDate).format('MM/DD/YYYY - HHmm')} hrs
                  </span>
                </p>
                <p className={style.twelvepx}>
                  {Lang.LBL_LOCATION}: <span>{value.location}</span>
                </p>
                <p className={style.twelvepx}>
                  {Lang.LBL_REQUESTOR_NAME}: <span>{value.requestorName}</span>
                </p>
              </div>
              <div className={style.subDetails}>
                <p className={style.twelvepx}>
                  {Lang.LBL_DISTRICT_PROJECT}:{' '}
                  <span>{value.requestorDistrict}</span>
                </p>
                <p className={style.twelvepx}>
                  {Lang.LBL_FLIGHT_TYPE}: <span>{value.flightType}</span>
                </p>
              </div>
            </div>
          </div>
        </>
      );
      setText(Lang.LBL_HIDE_DETAILS);
    } else {
      setText(Lang.LBL_SHOW_DETAILS);
      setDetails(<div />);
    }
  }, [details]);

  const url = getRequestUrl(
    {
      request: {
        requestId: value.requestId,
        flightFlag:
          value?.flightCategory === 'Patrol/Passenger - SCG'
            ? 6
            : value.flightCategoryKey ?? 1,
      },
    },
    {
      from: 'notifications',
    }
  );

  return (
    <>
      <div
        id={value?.requestId?.toString()}
        style={{ float: 'left', lineHeight: '30px' }}
      >
        <ATMIcon
          circular
          size="small"
          color={value.flightCategory?.includes('SCG') ? 'blue' : 'pink'}
          name={
            // eslint-disable-next-line no-nested-ternary
            value.flightCategory?.includes('Passenger')
              ? 'plane'
              : value.flightCategory?.includes('Construction')
              ? 'wrench'
              : 'servicestack'
          }
          style={{
            boxShadow: value.flightCategory?.includes('SCG')
              ? '0 0 0 0.08em rgb(33, 133, 208) inset'
              : '0 0 0 0.08em rgb(224, 57, 151) inset',
            marginRight: '0.75em',
            fontSize: '1.15em',
          }}
        />
        <Link to={url} className={style.colorBlack}>
          <span className={style.span}>
            {value.flightCategory}, {Lang.LBL_TICKET_NO} {value.requestId}
          </span>
        </Link>{' '}
        {value.requestStatus === RequestStatus.Cancelled
          ? Lang.MSG_REQUEST_CANCELLED
          : Lang.MSS_REQUEST_PENDING}{' '}
        <a className="hideshow" onClick={handleHideShow} role="button">
          {text}
        </a>
      </div>
      <div style={{ float: 'right', lineHeight: '30px' }}>
        <span
          style={{ color: '#797979', marginRight: '5px', fontSize: '12px' }}
        >
          {Moment(value.requestDate).fromNow(true)}
        </span>{' '}
        <RequestStatusView data={value} />
      </div>
      <div className={style.clear} />
      {details}
    </>
  );
};

export default NotificationRow;
